export const reviewTimestamp = (value) => Date.parse(value) || 0;
export function memberReviewSections(records = []) {
  const reviews = [],
    ratings = [];
  for (const record of records) {
    if (record.content?.trim()) reviews.push(record);
    else if (Number.isFinite(record.rating) && record.rating >= 0 && record.rating <= 5)
      ratings.push(record);
  }
  ratings.sort(
    (a, b) => reviewTimestamp(b.createdAt) - reviewTimestamp(a.createdAt) || b.id - a.id,
  );
  return { reviews, ratings };
}
export function sortMemberReviews(records, sort = 'latest', myReviewId) {
  return records
    .filter((r) => r.id !== myReviewId)
    .sort((a, b) => {
      const latest = reviewTimestamp(b.createdAt) - reviewTimestamp(a.createdAt) || b.id - a.id;
      if (sort === 'empathy') return (b.likeCount ?? 0) - (a.likeCount ?? 0) || latest;
      if (sort === 'ratingHigh') return b.rating - a.rating || latest;
      if (sort === 'ratingLow') return a.rating - b.rating || latest;
      return latest;
    });
}
export function ratingDistribution(records) {
  const counts = [0, 0, 0];
  records.forEach((r) => {
    counts[r.rating <= 2 ? 0 : r.rating <= 3.5 ? 1 : 2]++;
  });
  const total = counts.reduce((a, b) => a + b, 0);
  if (!total) return { counts, percentages: [0, 0, 0] };
  const exact = counts.map((c) => (c / total) * 100),
    percentages = exact.map(Math.floor);
  const priority = exact
    .map((n, i) => ({ fraction: n - percentages[i], index: i }))
    .sort((a, b) => b.fraction - a.fraction || b.index - a.index);
  for (let left = 100 - percentages.reduce((a, b) => a + b, 0), i = 0; left > 0; left--, i++)
    percentages[priority[i % 3].index]++;
  return { counts, percentages };
}
// Only ephemeral presentation state; never retain user content or credentials.
const views = new Map();
export const readMemberReviewView = (key) => views.get(key) ?? { tab: 'reviews', sort: 'latest' };
export function rememberMemberReviewView(key, value) {
  views.set(key, value);
  if (views.size > 40) views.delete(views.keys().next().value);
}
